import { getKnowledgeBaseEmptyState } from './KnowledgeBase';
export let FetchStatus;
(function (FetchStatus) {
  FetchStatus["NOT_STARTED"] = "NOT_STARTED";
  FetchStatus["PENDING"] = "PENDING";
  FetchStatus["SUCCEEDED"] = "SUCCEEDED";
  FetchStatus["ERROR"] = "ERROR";
})(FetchStatus || (FetchStatus = {}));
export const getKnowledgeBaseDetailsEmptyState = () => ({
  error: undefined,
  isRequesting: false,
  isUpdating: false,
  status: FetchStatus.NOT_STARTED,
  knowledgeBase: getKnowledgeBaseEmptyState(),
  lastLoaded: 0,
  lastUpdated: undefined
});